import styles from "./OpenQuestion.module.css";
import { useTranslation } from "react-i18next";

export default function OpenQuestion({ answerType = "str", value, onChange, details = {} }) {
    const isInt = answerType === "int";
    const { t } = useTranslation();
    const options = details.options || [];
    const textFields = details.textFields || [];
    const hasExtras = options.length > 0;
    const minVal = Number.isFinite(details.min) ? details.min : 0;
    const maxVal = Number.isFinite(details.max) ? details.max : undefined;

    const openVal = (value?.choice ?? "");
    const d = (value?.details && typeof value.details === "object") ? value.details : {};
    const selected = Array.isArray(d.selected) ? d.selected : [];
    const texts = (d.texts && typeof d.texts === "object") ? d.texts : {};

    const anyChecked = selected.length > 0;

    const handleOpenChange = (e) => {
        const raw = e.target.value;
        const nextOpen = isInt ? (raw === "" ? "" : Number(raw)) : raw;
        if (hasExtras) {
            onChange({ choice: nextOpen, details: { selected: [...selected], texts: { ...texts } } });
        } else {
            onChange({ choice: nextOpen });
        }
    };

    const toggleOption = (opt) => {
        // Single-select behavior like OpenList: selecting a new option replaces previous; clicking again deselects.
        const nextSelected = selected.includes(opt) ? [] : [opt];
        onChange({ choice: openVal ?? "", details: { selected: nextSelected, texts: { ...texts } } });
    };

    const handleTextChange = (opt, val) => {
        onChange({ choice: openVal ?? "", details: { selected: [...selected], texts: { ...texts, [opt]: val } } });
    };

    return (
        <div className={styles.wrap}>
            <input
                className={styles.input}
                type={isInt ? "number" : "text"}
                inputMode={isInt ? "numeric" : "text"}
                pattern={isInt ? "[0-9]*" : undefined}
                min={isInt ? minVal : undefined}
                max={isInt && Number.isFinite(maxVal) ? maxVal : undefined}
                value={openVal ?? ""}
                onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key) && isInt) {
                        e.preventDefault();
                    }
                }}
                onChange={handleOpenChange}
                // Block editing when an extra is selected (like OpenList behavior)
                disabled={hasExtras && anyChecked}
                placeholder={isInt ? t("placeholder.numberField") : t("placeholder.textField")}
            />
            {hasExtras && (
                <div className={styles.extraWrap}>
                    {options.map((opt, i) => {
                        const optLabel = typeof opt === 'object' && opt !== null ? opt.label : opt;
                        return (
                        <div key={i + 1} className={styles.optionRow}>
                            <label className={styles.optionLabel}>
                                <input
                                    type="checkbox"
                                    className={styles.checkbox}
                                    checked={selected.includes(i + 1)}
                                    onChange={() => toggleOption(i + 1)}
                                />
                                <span>{optLabel}</span>
                            </label>
                            {textFields.includes(i + 1) && (
                                <input
                                    type="text"
                                    className={styles.optionText}
                                    value={texts[i + 1] || ""}
                                    onChange={(e) => handleTextChange(i + 1, e.target.value)}
                                    disabled={!selected.includes(i + 1)}
                                    placeholder={!!selected.includes(i + 1) ? t("placeholder.textField") : ""}
                                    aria-label={`${optLabel} details`}
                                />
                            )}
                        </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}